import {HttpErrorResponse} from '@angular/common/http';
import {standardQuestionsFromDraft} from 'app/services/standard-question-draft';
import {isStandardVersionConflict} from 'app/services/standard-version';
const EMPTY_QUESTION_STATUS = '';
const QUESTION_CREATION_PHASE = 'ADDING_QUESTIONS';
const QUESTION_CREATION_ERROR = 'E_B_T_A';
const QUESTION_VERSION_CONFLICT_MESSAGE = 'STANDARD_VERSION_CONFLICT_MESSAGE';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import { AdminService } from '../../../services/admin.service';
import { Standard } from '../../../models/standard.model';
import { FullUser } from '../../../models/full-user.model';
import { UserService } from '../../../services/user.service';
import { Status } from '../../../models/status.model';
import { Group } from '../../../models/group.model';
import { Prefix } from '../../../models/prefix.model';
import { CreatingStandard } from '../../../models/creating-standard.model';
import { Question } from '../../../models/question.model';
import { ConfirmationPopupComponent } from '../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Answer } from '../../../models/answer.model';
import { NewBlank } from '../../../models/new-blank.model';
import { MultiQuestions } from '../../../models/multi-questions';
import * as moment from 'moment';
import { PrefixService } from '../../../services/prefix.service';
import { EditStandardPrefixComponent } from '../../admin/create-standard/modal/edit-standard-prefix/edit-standard-prefix.component';
import { AddStandardPrefixComponent } from '../../admin/create-standard/modal/add-standard-prefix/add-standard-prefix.component';
import { StandardTypesService } from '../../../services/standard-types.service';
import { StandardType } from '../../../models/standard-type.model';
import { AddStandardTypeComponent } from '../../admin/create-standard/modal/add-standard-type/add-standard-type.component';
import { EditStandardTypeComponent } from '../../admin/create-standard/modal/edit-standard-type/edit-standard-type.component';
import { EditStandardNumberComponent } from '../../admin/create-standard/modal/edit-standard-number/edit-standard-number.component';
import { TreeGroupPosService } from '../create-operating-standard/tree-group-pos-service/tree-group-pos.service';
import { AnswerGroupPos } from '../create-operating-standard/tree-group-pos-service/answer-group-pos.model';
import { StepsControllerService } from "../../../services/steps-controller.service";
import { User } from '../../../models/user.model';
import { StandardDiscussionApiService } from '../../common/standard-discussion/services/standard-discussion-api.service';
import { StandardAiQuestionGenerationStatus } from '../../../models/standard-ai-question-generation.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../services/toast.service';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/takeUntil';

const AI_LANGUAGE_RUSSIAN = 'RUSSIAN';
const MIN_STANDARD_CREATION_QUESTIONS = 5;
const HTTP_OK = 200;
const HTTP_NO_CONTENT = 204;
const FIRST_LIST_ITEM_INDEX = 0;
const USER_FIRST_NAME_FIELD = 'firstName';
const USERS_LIST_NAME = 'users';
const NOT_FOUND_INDEX = -1;
const ONE_ITEM = 1;
const AI_STATUS_SUCCEEDED = 'SUCCEEDED';
const AI_STATUS_TRANSLATION_PREFIX = 'STANDARD_AI_QUESTIONS_STATUS_';
const AI_GENERATE_ERROR_KEY = 'STANDARD_AI_QUESTIONS_GENERATE_ERROR';
const AI_APPLIED_TO_FORM_KEY = 'STANDARD_AI_QUESTIONS_APPLIED_TO_FORM';
const FIRST_DAILY_STANDARD_NUMBER = 1;
const STANDARD_NUMBER_SEPARATOR = '.';
const STANDARD_DATE_FORMAT = 'DD.MM.YYYY';
const HTTP_CREATED = 201;
const HTTP_ALREADY_EXISTS = 208;
const CREATING_STANDARD = 'CREATING_THE_STANDARD';
const CREATE_STANDARD_ERROR = 'ERROR_CREATING_THIS_STANDARD';
const FIVE_QUESTIONS_ERROR = 'YOU_NEED_AT_LEAST_FIVE_QUESTIONS';
const RUSSIAN_DOCUMENT = 'RU_DOC';
const ENGLISH_DOCUMENT = 'EN_DOC';
const DOCUMENT_REQUIRED = 'F_X_S';
const ASSIGNMENT_REQUIRED = 'S_P_D_S';
const TYPE_REQUIRED = 'TEIS';
const MAIN_INFO_REQUIRED = 'M_S_L';
const INVALID_BLANKS = 'SBIINF';
const LANGUAGE_ENGLISH = 'english';
const NUMBER_EXISTS = 'T_TRY';

interface StandardUser extends FullUser {
	fullName?: string;
}

@Component({
	selector: 'app-create-standard',
	templateUrl: './create-standard.component.html',
	styleUrls: ['./create-standard.component.css']
})

export class CreateStandardComponent implements OnInit, OnDestroy {
    private referenceRequest = new Subscription();
    private numberRequest = new Subscription();
	isLoaded = false;
	stringDate: string;
	generadedNumber: string;
	numberCountToday: number;
	standardNumber: string;
	selectedGroupObj: Group;
	users = [];
	groups: any = [];
	activeStep = 1;
	list = [];
	nextButText = 'NEXT';
	formData: FormData = new FormData();
	initiator: FullUser;
	groupStandardId: string;
	statuses = Status;
	status: Status = Status.ACTIVE;
	statusText: 'ACTIVE';
	selPositions: string[] = [];
	selGroups: string[] = [];
	selUsers: string[] = [];
	russianQuestions: Question[] = [];
	englishQuestions: Question[] = [];
	questionList: any[] = [];
	newBlanks: NewBlank[] = [];
	failedRetrieveEntities = false;
	failedStandardCreation = false;
	createSuccess = false;
	standard: any;
	ruDocLoaded: boolean;
	ruPptLoaded: boolean;
	ruPdfLoaded: boolean;
	enDocLoaded: boolean;
	enPptLoaded: boolean;
	enPdfLoaded: boolean;
	needMoreQuestions = false;
	errorMessage = '';
	invalidQuestions = false;
	selectedType: StandardType;
	creatingStatusText = '';
	newList = [];
	showCreateError = false;
	disableBtnCreateStandard = false;
	user: User;
	isAdmin = false;
	isHead = false;
	isUser = false;
	flag = true;
	flagNg = true;
	isSelected = false;
	checkbox=true;
	private destroy$ = new Subject<void>();
	private initiatorRequest = new Subscription();

	isNextButtonHovered = false;
	highlightStep1Name = false;
	highlightStep1Annotation = false;
	highlightStep2Document = false;
	isAiDraftQuestionGenerating = false;
	showAiDraftQuestionStatus = false;
	aiDraftQuestionStatusKey = '';
	minQuestions = MIN_STANDARD_CREATION_QUESTIONS;

	constructor(private userService: UserService,
		private adminService: AdminService,
		private modalService: NgbModal,
		public prefixService: PrefixService,
		public standardTypesService: StandardTypesService,
		public treeGroupPosService: TreeGroupPosService,
		public setpsControllService: StepsControllerService,
		private discussionApi: StandardDiscussionApiService,
		private router: Router,
		private translate: TranslateService,
		private toastService: ToastService) {
	}

ngOnInit(): void {
		this.checkRole();
		this.creatingStatusText = EMPTY_QUESTION_STATUS;
		this.showCreateError = this.disableBtnCreateStandard = false;
		this.isLoaded = false;
		this.stringDate = moment().format(STANDARD_DATE_FORMAT);
		this.resetNewStandardContext();
		this.getUsersByIdGroup(this.getCurrentUserFromStorage().mainGroup);
		this.loadCreationGroups().takeUntil(this.destroy$)
			.subscribe(response => this.acceptCreationGroups(response), () => this.rejectReferences());
	}

	private acceptCreationGroups(response: HttpResponse<Object>): void {
		if (!Array.isArray(response.body)) { this.rejectReferences(); return; }
		const mainGroupId = this.getCurrentUserFromStorage().mainGroup;
		this.groups = (response.body as Group[]).slice().sort((left, right) => left.name.localeCompare(right.name));
		const relatedIndex = this.groups.findIndex(group => group.id === mainGroupId);
		if (relatedIndex !== NOT_FOUND_INDEX) { this.groups.unshift(this.groups.splice(relatedIndex, ONE_ITEM)[FIRST_LIST_ITEM_INDEX]); }
		if (!this.groups.length) { this.isLoaded = true; return; }
		this.setDivisionInitiator(this.groups[FIRST_LIST_ITEM_INDEX].id, false);
		this.retryGroups();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
	
	getUsersByIdGroup(id) {
		this.initiatorRequest.unsubscribe();
		this.users = [];
		this.initiator = undefined;
		if (!this.isAdmin && this.isHead) {
			this.setCurrentUserAsInitiator();
			return;
		}
		if (this.groupStandardId !== id) {
			return;
		}
		this.initiatorRequest = this.userService.getUsersByIdGroup(id).takeUntil(this.destroy$).subscribe(
			(response: HttpResponse<Object>) => this.acceptInitiatorUsers(id, response),
			() => this.failInitiatorUsers(id)
		);
	}

	private acceptInitiatorUsers(id: string, response: HttpResponse<Object>): void {
		if (this.groupStandardId === id) {
			this.failedRetrieveEntities = false;
			this.handleUsersResponse(response);
		}
	}

	private failInitiatorUsers(id: string): void {
		if (this.groupStandardId === id) {
			this.failedRetrieveEntities = true;
		}
	}

	private setCurrentUserAsInitiator() {
		const currentUser = this.getCurrentUserFromStorage();
		this.users = currentUser && currentUser.id ? [currentUser] : [];
		this.initiator = this.users[FIRST_LIST_ITEM_INDEX];
	}

	private handleUsersResponse(response: HttpResponse<Object>) {
		if (response.status === HTTP_OK) {
			if (this.isAdmin && this.isHead) {
				this.setAdminHeadUsers(response.body ? response.body as StandardUser[] : []);
			} else if (this.isAdmin && !this.isHead) {
				this.users = response.body ? response.body as StandardUser[] : [];
				this.initiator = this.users[FIRST_LIST_ITEM_INDEX];
			}
		} else if (response.status === HTTP_NO_CONTENT) {
			this.users = [];
		}
	}

	private setAdminHeadUsers(responseUsers: StandardUser[]) {
		const users = responseUsers.slice();
		const currentUser = this.getCurrentUserFromStorage();
		const relatedId = users.findIndex((user: StandardUser) => user.fullName === currentUser.fullName);
		const related = relatedId === NOT_FOUND_INDEX ? null : users.splice(relatedId, ONE_ITEM)[FIRST_LIST_ITEM_INDEX];
		this.users = users;
		this.filterBy(USER_FIRST_NAME_FIELD, USERS_LIST_NAME);
		if (related) {
			this.users.unshift(related);
		}
		this.initiator = this.users[FIRST_LIST_ITEM_INDEX];
	}

	private resetNewStandardContext() {
		this.setpsControllService.clearCurrentStandard();
		this.setpsControllService.clearTempData();
		this.treeGroupPosService.clearPositionsForServerLists();
	}

	private getCurrentUserFromStorage() {
		return JSON.parse(localStorage.getItem('User') || '{}');
	}

	ffffQuestionTest(i, value){
		if(value) {
			this.questionList[i].checked = false;
		} else {
			this.questionList[i].checked = true;
		}
	}

	changeQuestionTest(i, value) {
		this.questionList[i].questionTextRu = value;
		this.questionList[i].questionTextEn = value;
		this.chekQuestionArr();
	}

	chekQuestionArr() {
		var n = this.questionList.length;
		for (var i = 0; i < n-1; i++)
		{ for (var j = i+1; j < n; j++)
			{ if (this.questionList[i].questionTextRu === this.questionList[j].questionTextRu) return false; }
		}
		return true;
	}

	changeAnswerOne(i, value) {
		this.questionList[i].answers[0].answerOneRu = value;
		this.questionList[i].answers[0].answerOneEn = value;
	}

	changeAnswerTwo(i, value) {
		this.questionList[i].answers[0].answerTwoRu = value;
		this.questionList[i].answers[0].answerTwoEn = value;
	}

	changeAnswerThree(i, value) {
		this.questionList[i].answers[0].answerThreeEn = value;
		this.questionList[i].answers[0].answerThreeRu = value;
	}

	changeRightAnswer(i, value) {
		this.questionList[i].rightAnswerRu = value;
		this.questionList[i].rightAnswerEn = value;
	}

	
	fileChange(typeRu: string, typeEn: string, event) {
		this.ruSet(this.getStandardDocumentType(typeRu, typeEn), event);
	}

	fileChangePresent(typeRu: string, typeEn: string, event) {
		this.ruSet(typeRu, event);
	}	

	ruSet(type, event){
		const fileList = event.target.files;
		if (fileList.length > 0) {
		  const file: File = fileList[0];
		  this.formData.set(type, file, file.name);
		  this.list.push(file.name);
		  if(type === 'RU_DOC') {
		    this.ruDocLoaded = true;
		  }
		  if(type === 'EN_DOC') {
		    this.enDocLoaded = true;
		  }
		} else {
		  this.formData.delete(type);
		  if(type === 'RU_DOC') {
		    this.ruDocLoaded = false;
		  }
		  if(type === 'EN_DOC') {
		    this.enDocLoaded = false;
		  }
		}
	}
	
	enSet(type, event){
		const fileList = event.target.files;
		if (fileList.length > 0) {
		  const file: File = fileList[0];
		  this.formData.set(type, file, file.name);
		  this.list.push(file.name);
		} else {
		  this.formData.delete(type);
		}
	}

	checkRole() {
		this.user = this.userService.getLocal();
		if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
	}
	
retryGroups(): void {
		this.referenceRequest.unsubscribe();
		const groupId = this.selectedGroupObj.id;
		this.failedRetrieveEntities = false;
		this.referenceRequest = Observable.forkJoin(this.prefixService.getPrefixesForGroup(groupId),
			this.standardTypesService.getTypesForGroup(groupId)).takeUntil(this.destroy$)
			.subscribe(responses => this.acceptReferences(responses), () => this.rejectReferences());
	}

	private acceptReferences(responses: [HttpResponse<Prefix[]>, HttpResponse<Object>]): void {
		const prefixes = responses[FIRST_LIST_ITEM_INDEX].body || [];
		const selected = prefixes[FIRST_LIST_ITEM_INDEX];
		const previous = this.prefixService.getSelectedPrefix();
		this.prefixService.setGroupPrefixex(prefixes);
		this.prefixService.setSelectedPrefix(selected);
		if (!previous || !selected || previous.id !== selected.id || !this.prefixService.customStndNumber) {
			this.setCounterNum(selected);
		}
		this.updateTypes(responses[ONE_ITEM].body || []);
		this.isLoaded = true;
	}

	private rejectReferences(): void {
		this.isLoaded = this.failedRetrieveEntities = true;
	}

	diabledNextSteps(form) {
		return this.isValid(form) && this.isStandardAssignmentValid();
	}

	goToStepOne() {
		this.activeStep = 1;
		this.nextButText = 'NEXT';
	}

	goToStepTwo() {
		this.activeStep = 2;
		this.nextButText = 'NEXT';
	}

	goToStepThree() {
		this.activeStep = 3;
		this.nextButText = 'NEXT';
	}

	goToPrev() {
		if (this.activeStep > 1) {
			this.activeStep--;
			this.nextButText = 'NEXT';
		}
		if (this.activeStep < 1) {
			this.activeStep = 1;
		}
	}

	goToNext() {
		if (this.activeStep < 3) {
			this.activeStep++;
		}
		if (this.activeStep > 3) {
			this.activeStep = 3;
		}
	}

	addQuestionToList() {
		this.questionList.push(
			{
				checked: true,
				questionTextRu: '',
				questionTextEn: '',
				rightAnswerRu: '',
				rightAnswerEn: '',
				answers: [
					{
						answerOneRu: '',
						answerTwoRu: '',
						answerThreeRu: '',
						answerOneEn: '',
						answerTwoEn: '',
						answerThreeEn: '',
					}
				]
			}
		);
	}

	validationBlank(blank) {
		return blank.number !== null &&
			blank.name !== null &&
			blank.formData;
	}

	cnhageBlankInfo(event, i){
		this.newBlanks[i].name = event;
		this.newBlanks[i].number = this.prefixService.customStndNumber + '_blank_' + (i + 1);
	}

	private validationAllBlanks(newBlanks: NewBlank[]): boolean {
		for (const blank of newBlanks) {
			if (!this.validationBlank(blank)) {
				return false;
			}
		}
		return true;
	}

	addNewBlank() {
		this.newBlanks.push(new NewBlank(null, null, null));
	}

	deleteBlank(key) {
		if (key > -1) {
			this.newBlanks.splice(key, 1);
		}
	}

	deleteQuestionFromList(key) {
		if (key > -1) {
			this.questionList.splice(key, 1);
		}
	}

	generateDraftAiQuestions(form: NgForm): void {
		if (this.isAiDraftQuestionGenerating || !this.formData.has(this.getStandardDocumentType('RU_DOC', 'EN_DOC'))) {
			return;
		}
		this.isAiDraftQuestionGenerating = true;
		this.showAiDraftQuestionStatus = false;
		this.adminService.generateDraftStandardAiQuestions(this.buildDraftAiQuestionRequest(form), AI_LANGUAGE_RUSSIAN)
			.subscribe(
				(response: HttpResponse<StandardAiQuestionGenerationStatus>) => this.handleDraftAiQuestionResponse(response),
				() => this.handleDraftAiQuestionError()
			);
	}

	private buildDraftAiQuestionRequest(form: NgForm): FormData {
		const request = new FormData();
		const documentKey = this.getStandardDocumentType('RU_DOC', 'EN_DOC');
		const document = this.formData.get(documentKey);
		request.append('standardNumber', this.prefixService.customStndNumber || this.standardNumber || this.generadedNumber || '');
		request.append('standardName', form.value.ruName || '');
		request.append('standardAnnotation', form.value.ruAnnotation || '');
		request.append('document', document, this.getDraftDocumentName(document));
		return request;
	}

	private handleDraftAiQuestionResponse(response: HttpResponse<StandardAiQuestionGenerationStatus>): void {
		this.isAiDraftQuestionGenerating = false;
		const body = response.body;
		if (!body || body.status !== AI_STATUS_SUCCEEDED || !body.questions || body.questions.length < MIN_STANDARD_CREATION_QUESTIONS) {
			this.showDraftAiQuestionStatus(body ? AI_STATUS_TRANSLATION_PREFIX + body.status : AI_GENERATE_ERROR_KEY);
			return;
		}
		this.questionList = body.questions.map((question: Question) => this.toQuestionListItem(question));
		this.showDraftAiQuestionStatus(AI_APPLIED_TO_FORM_KEY);
	}

	private handleDraftAiQuestionError(): void {
		this.isAiDraftQuestionGenerating = false;
		this.showDraftAiQuestionStatus('STANDARD_AI_QUESTIONS_GENERATE_ERROR');
	}

	private showDraftAiQuestionStatus(statusKey: string): void {
		this.aiDraftQuestionStatusKey = statusKey;
		this.showAiDraftQuestionStatus = true;
	}

	private toQuestionListItem(question: Question): any {
		const answers = question.answers || [];
		const answerOne = this.answerText(answers[0]);
		const answerTwo = this.answerText(answers[1]);
		const answerThree = this.answerText(answers[2]);
		const rightAnswer = this.rightAnswerNumber(question);
		return {
			checked: this.isGeneratedQuestionTesting(question),
			questionTextRu: question.questionText || '',
			questionTextEn: question.questionText || '',
			rightAnswerRu: rightAnswer,
			rightAnswerEn: rightAnswer,
			answers: [
				{
					answerOneRu: answerOne,
					answerTwoRu: answerTwo,
					answerThreeRu: answerThree,
					answerOneEn: answerOne,
					answerTwoEn: answerTwo,
					answerThreeEn: answerThree,
				}
			]
		};
	}

	private rightAnswerNumber(question: Question): string {
		const rightAnswerText = this.answerText(question.rightAnswer);
		const index = (question.answers || []).findIndex((answer: Answer) => this.answerText(answer) === rightAnswerText);
		return String(index >= 0 ? index + 1 : 1);
	}

	private answerText(answer: Answer): string {
		return answer && answer.answerText ? answer.answerText : '';
	}

	private isGeneratedQuestionTesting(question: Question): boolean {
		const value = question && (question as any).isTesting !== undefined
			? (question as any).isTesting
			: question && (question as any).testing;
		return value !== false;
	}

	private getDraftDocumentName(document: any): string {
		return document && document.name ? document.name : 'standard.docx';
	}

	setInitiator(login: string): void {
		this.initiator = this.users.find(value => value.login === login);
	}

	setStatus(status): void {
		this.statusText = status;
	}


	isValidQuestion(answerOne, answerTwo, answerThree): boolean {
		return answerOne === answerTwo ||
			answerOne === answerThree;
	}

	sendRequest(form: NgForm): void {
		const modalRef = this.modalService.open(ConfirmationPopupComponent);
		modalRef.componentInstance.massage = 'E_C';
		modalRef.result.then((result) => {
			if (result === 'ok') {
				this.isLoaded = false;
				this.createStandard(form);
			}
		});
	}


createStandard(form: NgForm): void {
		this.disableBtnCreateStandard = true;
		this.showCreateError = this.needMoreQuestions = this.invalidQuestions = this.createSuccess = false;
		this.errorMessage = EMPTY_QUESTION_STATUS;
		this.isLoaded = true;
		if (!this.validCreationQuestions()) { this.disableBtnCreateStandard = false; return; }
		const error = this.creationInputError(form);
		if (error) { this.rejectCreation(error); return; }
		this.creatingStatusText = CREATING_STANDARD;
		this.adminService.createHeadStandard(this.creationRequest(form)).takeUntil(this.destroy$)
			.subscribe(response => this.acceptCreation(response), () => {
				this.failedStandardCreation = true;
				this.rejectCreation(CREATE_STANDARD_ERROR);
			});
	}

	private validCreationQuestions(): boolean {
		this.needMoreQuestions = this.questionList.length < MIN_STANDARD_CREATION_QUESTIONS || !this.chekQuestionArrValue();
		if (this.needMoreQuestions) { this.errorMessage = FIVE_QUESTIONS_ERROR; return false; }
		this.invalidQuestions = !this.chekQuestionArr();
		return !this.invalidQuestions;
	}

	private creationInputError(form: NgForm): string {
		if (!this.formData.has(this.getStandardDocumentType(RUSSIAN_DOCUMENT, ENGLISH_DOCUMENT))) { return DOCUMENT_REQUIRED; }
		if (!this.isStandardAssignmentValid()) { return ASSIGNMENT_REQUIRED; }
		if (!this.standardTypesService.getSelectedType()) { return TYPE_REQUIRED; }
		if (!this.prefixService.getSelectedPrefix() || !this.isValid(form)) { return MAIN_INFO_REQUIRED; }
		if (!this.validationAllBlanks(this.newBlanks)) { return INVALID_BLANKS; }
		return EMPTY_QUESTION_STATUS;
	}

	private creationRequest(form: NgForm): CreatingStandard {
		const language = this.getStandardLanguage();
		const english = language === LANGUAGE_ENGLISH;
		const type = this.standardTypesService.getSelectedType() as StandardType;
		return new CreatingStandard(this.stringDate, {id: type.id, ruName: type.ruName, enName: type.enName},
			this.prefixService.customStndNumber, this.initiator.id, this.groupStandardId,
			english ? null : form.value.ruAnnotation, english ? null : form.value.ruName, english ? null : form.value.ruType,
			english ? form.value.ruAnnotation : null, english ? form.value.ruName : null, english ? form.value.ruType : null,
			Status[Status.NEW], this.selGroups, this.selUsers, this.selPositions,
			this.getStandardDisseminationPositions(), language);
	}

	private acceptCreation(response: HttpResponse<Object>): void {
		if (response.status !== HTTP_CREATED && response.status !== HTTP_OK) {
			this.rejectCreation(response.status === HTTP_ALREADY_EXISTS ? NUMBER_EXISTS : CREATE_STANDARD_ERROR);
			return;
		}
		this.standard = response.body as Standard;
		this.flag = false;
		this.addQuestionsToStandard(this.standard);
	}

	private rejectCreation(errorKey: string): void {
		this.creatingStatusText = EMPTY_QUESTION_STATUS;
		this.showCreateError = true;
		this.errorMessage = errorKey;
		this.disableBtnCreateStandard = false;
	}

  private addQuestionsToStandard(standard: Standard): void {
    this.isLoaded = false;
    this.creatingStatusText = QUESTION_CREATION_PHASE;
    const questions = standardQuestionsFromDraft(this.questionList);
    this.adminService.addQuestionsToStandard(questions, standard).takeUntil(this.destroy$).subscribe(() => {
      this.russianQuestions = [];
      this.englishQuestions = [];
      this.uploadFiles(standard);
    }, error => this.rejectQuestionCreation(error));
  }

  private rejectQuestionCreation(error: HttpErrorResponse): void {
    this.creatingStatusText = EMPTY_QUESTION_STATUS;
    this.showCreateError = true;
    this.errorMessage = isStandardVersionConflict(error) ? QUESTION_VERSION_CONFLICT_MESSAGE : QUESTION_CREATION_ERROR;
    this.disableBtnCreateStandard = false;
    this.isLoaded = true;
  }

	blanksChange(event, index: number) {
		const fileList = event.target.files;
		if (fileList.length > 0) {
			const file: File = fileList[0];
			const formData = new FormData();
			formData.append('file', file, file.name);
			this.newBlanks[index].formData = formData;
		}
	}

	private uploadFiles(standard: Standard) {
		this.creatingStatusText = 'UPLOADING_FILES';
		this.isLoaded = false;
		this.adminService.uploadFiles(standard, this.formData).subscribe(
			(res: any) => {
				this.isLoaded = false;
				if (res.status === 200 || res.status === 201) {
					this.uploadBlanks(this.standard);
				} else {
					this.creatingStatusText = '';
					this.showCreateError = true;
					this.errorMessage = 'E_B_S_T';
					this.disableBtnCreateStandard = false;
					this.isLoaded = true;
				}
			}, () => {
				this.creatingStatusText = '';
				this.showCreateError = true;
				this.errorMessage = 'E_B_S_T';
				this.disableBtnCreateStandard = false;
				this.isLoaded = true;
			}
		);
	}

	private uploadBlanks(standard: Standard) {
		this.isLoaded = false;
		if (this.newBlanks.length > 0) {
			this.creatingStatusText = 'UPLOADING_BLANKS';
			this.isLoaded = false;
			this.adminService.uploadBlank(standard, this.newBlanks).subscribe(
				(res: any) => {
					this.isLoaded = false;
					if (res.status === 200 || res.status === 201) {
						this.startDiscussion();
					} else {
						this.creatingStatusText = '';
						this.showCreateError = true;
						this.errorMessage = 'E_B_S_T_A';
						this.disableBtnCreateStandard = false;
						this.isLoaded = true;
					}
				},
				() => {
					this.creatingStatusText = '';
					this.showCreateError = true;
					this.errorMessage = 'E_B_S_T_A';
					this.disableBtnCreateStandard = false;
					this.isLoaded = true;
				}
			);
		} else {
			this.startDiscussion();
		}
		this.isLoaded = true;
	}

	private getStandardLanguage(): string {
		const user = this.userService.getLocal();
		const language = user && user.language ? user.language.toLowerCase() : 'russian';
		return language === 'english' || language === 'en' ? 'english' : 'russian';
	}

	private getStandardDocumentType(typeRu: string, typeEn: string): string {
		return this.getStandardLanguage() === 'english' ? typeEn : typeRu;
	}

	private startDiscussion(): void {
		this.creatingStatusText = 'STANDARD_DISCUSSION_SENDING';
		this.discussionApi.startDiscussion(this.standard.id).subscribe(
			(response: any) => this.openDiscussion(response),
			() => this.showDiscussionError()
		);
	}

	private openDiscussion(response: any): void {
		this.setCounterNum(this.prefixService.getSelectedPrefix());
		this.disableBtnCreateStandard = false;
		this.creatingStatusText = '';
		this.isLoaded = true;
		this.toastService.success(this.translate.instant('STANDARD_DISCUSSION_PUBLISH_SUCCESS'));
		this.router.navigate([this.getStandardsListRoute()]);
	}

	private getStandardsListRoute(): string {
		if (this.isAdmin && this.isHead) {
			return '/dashboard/admin/all-standards-head';
		}
		if (this.isAdmin && !this.isHead) {
			return '/dashboard/admin/standards-management-admin';
		}
		if (!this.isAdmin && this.isHead) {
			return '/dashboard/admin/all-standards-head-only';
		}
		return '/dashboard/my-created-standards';
	}

	canChooseStandardAssignments(): boolean {
		return this.isAdmin || this.isHead;
	}

	private loadCreationGroups(): Observable<HttpResponse<Object>> {
		return this.isAdmin ? this.adminService.getGroupsAndPositions() : this.adminService.getGroupsAndPositionsHead();
	}

	private isStandardAssignmentValid(): boolean {
		if (!this.canChooseStandardAssignments()) {
			return !!this.groupStandardId;
		}
		return this.treeGroupPosService.isValid();
	}

	private getStandardDisseminationPositions(): AnswerGroupPos[] {
		if (!this.canChooseStandardAssignments()) {
			return this.groupStandardId ? [new AnswerGroupPos(this.groupStandardId, false)] : [];
		}
		return this.treeGroupPosService.getReadeForServer();
	}

	private showDiscussionError(): void {
		this.creatingStatusText = '';
		this.showCreateError = true;
		this.errorMessage = 'STANDARD_DISCUSSION_LOAD_ERROR';
		this.disableBtnCreateStandard = false;
		this.isLoaded = true;
	}

	isValid(form: NgForm) {
		return form.value.ruAnnotation !== '' && form.value.ruAnnotation != null
			&& form.value.ruName !== '' && form.value.ruName != null;
	}

	fieldsChangeGroup(values: any, group) { // JUST
		if(this.isSelected) {
			this.isSelected = false;
		} else {
			this.isSelected = true;
		}
		
	}

	chekQuestionArrValue() {
		var n = this.questionList.length;
		for (var i = 0; i < n; i++){
		 if (this.questionList[i].questionTextRu === '' || 
     this.questionList[i].answers[0].answerOneRu === '' || 
     this.questionList[i].answers[0].answerTwoRu === '' || 
     this.questionList[i].answers[0].answerThreeRu === '' ||
     this.questionList[i].rightAnswerRu === '') 
     return false; }
		return true;
	}

	isQuestionsValid() {
		for (const question of this.questionList) {
			if (question.questionTextRu === ''
				|| question.questionTextEn === ''
				|| (question.rightAnswerRu < 1 || question.rightAnswerRu > 3)
				|| (question.rightAnswerEn < 1 || question.rightAnswerEn > 3)) {
				return false;
			}
			for (const answer of question.answers) {
				if (answer.answerOneRu === ''
					|| answer.answerTwoRu === ''
					|| answer.answerThreeRu === ''
					|| answer.answerOneEn === ''
					|| answer.answerTwoEn === ''
					|| answer.answerThreeEn === '') {
					return false;
				}
				if (answer.answerOneRu === answer.answerTwoRu) {
					return false;
				}
				if (answer.answerTwoRu === answer.answerThreeRu) {
					return false;
				}
				if (answer.answerOneRu === answer.answerThreeRu) {
					return false;
				}
				if (answer.answerOneEn === answer.answerTwoEn) {
					return false;
				}
				if (answer.answerTwoEn === answer.answerThreeEn) {
					return false;
				}
				if (answer.answerOneEn === answer.answerThreeEn) {
					return false;
				}
			}
		}
		return true;
	}

	setNumberPrefix(prefixName) {
		const prefixObj = this.prefixService.getGroupPrefixex().find(i => i.name === prefixName);
		this.prefixService.setSelectedPrefix(prefixObj);

		this.setCounterNum(prefixObj);
		this.prefixService.customStndNumber = this.prefixService.getNumberPrefix() + this.generadedNumber;
	}

	// UPDATE TYPES IN TYPES LIST IN SERVICE
	updateTypes(listOfTypes) {
		if (listOfTypes !== null && listOfTypes !== undefined) {
			this.prefixService.updateTypesList(listOfTypes);
		} else {
			this.prefixService.updateTypesList([]);
		}
	}

setCounterNum(prefixObj: Prefix): void {
		this.numberRequest.unsubscribe();
		this.applyNumber(prefixObj, FIRST_DAILY_STANDARD_NUMBER);
		if (!prefixObj) { return; }
		const initialNumber = this.prefixService.customStndNumber;
		this.numberRequest = this.prefixService.getCountStandardNumber(prefixObj.id).takeUntil(this.destroy$)
			.subscribe(response => {
				if (this.prefixService.customStndNumber !== initialNumber) { return; }
				this.applyNumber(prefixObj, Number(response.body) + FIRST_DAILY_STANDARD_NUMBER);
			}, () => this.rejectReferences());
	}

	private applyNumber(prefix: Prefix, dailyNumber: number): void {
		this.numberCountToday = dailyNumber;
		this.generadedNumber = STANDARD_NUMBER_SEPARATOR + dailyNumber + STANDARD_NUMBER_SEPARATOR + this.stringDate;
		const prefixText = prefix ? (prefix.numberPrefix || prefix.name) : EMPTY_QUESTION_STATUS;
		this.standardNumber = this.prefixService.customStndNumber = prefixText + this.generadedNumber;
	}

	setType(typeID) {
		const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
		this.standardTypesService.setSelectedType(typeObj);
		this.selectedType = typeObj;
	}

	openAddNewPrefixModal() {
		const addPrefix = this.modalService.open(AddStandardPrefixComponent);
		addPrefix.componentInstance.setPrefixList(this.prefixService.getGroupPrefixex());
		addPrefix.componentInstance.setGroupForNewPrefix(this.selectedGroupObj);
		addPrefix.componentInstance.setStrinfDate(this.stringDate);
	}

	openEditPrefixModal() {
		if (this.prefixService.getSelectedPrefix() && this.prefixService.getSelectedPrefix().id) {
			const modalRef = this.modalService.open(EditStandardPrefixComponent);
			modalRef.componentInstance.setGroupForPrefix(this.prefixService.getSelectedPrefix());
		} else {
			this.retryGroups();
		}
	}

	openEditNumberModal() {
		if (!this.prefixService.getSelectedPrefix()) { return; }
		const newStr = this.prefixService.customStndNumber.slice(this.prefixService.getNumberPrefix().length);
		const modalRef = this.modalService.open(EditStandardNumberComponent);
		modalRef.componentInstance.setCurrentNumber(newStr);
	}

	openAddNewTypeModal() {
		const modalRef = this.modalService.open(AddStandardTypeComponent);
		modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
	}

	openEditTypeModal() {
		const modalRef = this.modalService.open(EditStandardTypeComponent);
		modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
	}

	setDivisionInitiator(groupID, shouldRetryGroups = true) {
		const groupObj = this.groups.find(i => i.id === groupID);
		if (!groupObj) {
			return;
		}
		this.selectedGroupObj = groupObj;
		this.groupStandardId = groupID;
		this.setDivisionInitiatorUser(groupObj);
		this.prefixService.setActiveInitiatorGroup(groupObj);
		if (shouldRetryGroups) {
			this.retryGroups();
		}
	}

	private setDivisionInitiatorUser(groupObj: Group) {
		if (!this.canChooseStandardAssignments()) {
			this.setCurrentUserAsInitiator();
			return;
		}
		this.getUsersByIdGroup(groupObj.id);
	}

	filterBy(prop: string, list: string) {
		if (list === 'departments') {
			if (this.groups !== undefined) {
				return this.groups.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
			}
		}
		if (list === 'users') {
			if (this.users !== undefined) {
				return this.users.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
			}
		}
	}

	getDepartmentById(id) {
		this.setDivisionInitiator(id);
	}

	onNextButtonMouseEnter(step: number) {
		this.isNextButtonHovered = true;
		if (step === 1) {
			this.updateStep1FieldHighlights();
		} else if (step === 2) {
			this.updateStep2FieldHighlights();
		}
	}

	onNextButtonMouseLeave() {
		this.isNextButtonHovered = false;
		this.highlightStep1Name = false;
		this.highlightStep1Annotation = false;
		this.highlightStep2Document = false;
	}

	updateStep1FieldHighlights() {
		const nameInput = document.querySelector('input[name="ruName"]') as HTMLInputElement;
		const annotationInput = document.querySelector('input[name="ruAnnotation"]') as HTMLInputElement;
		
		this.highlightStep1Name = !nameInput || !nameInput.value || nameInput.value.trim() === '';
		this.highlightStep1Annotation = !annotationInput || !annotationInput.value || annotationInput.value.trim() === '';
	}

	updateStep2FieldHighlights() {
		this.highlightStep2Document = !this.formData.has(this.getStandardDocumentType('RU_DOC', 'EN_DOC'));
	}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard/create-standard.component.ts